"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Farm Infra Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.181
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubnetApi = exports.SubnetApiFactory = exports.SubnetApiFp = exports.SubnetApiAxiosParamCreator = exports.SnapshotApi = exports.SnapshotApiFactory = exports.SnapshotApiFp = exports.SnapshotApiAxiosParamCreator = exports.ShardApi = exports.ShardApiFactory = exports.ShardApiFp = exports.ShardApiAxiosParamCreator = exports.NetworkGroupApi = exports.NetworkGroupApiFactory = exports.NetworkGroupApiFp = exports.NetworkGroupApiAxiosParamCreator = exports.NetworkDeviceApi = exports.NetworkDeviceApiFactory = exports.NetworkDeviceApiFp = exports.NetworkDeviceApiAxiosParamCreator = exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiAxiosParamCreator = exports.FarmApi = exports.FarmApiFactory = exports.FarmApiFp = exports.FarmApiAxiosParamCreator = exports.DeviceApi = exports.DeviceApiFactory = exports.DeviceApiFp = exports.DeviceApiAxiosParamCreator = exports.CredentialApi = exports.CredentialApiFactory = exports.CredentialApiFp = exports.CredentialApiAxiosParamCreator = exports.IWIFIChannelEnum = exports.IEventTypeEnum = exports.ICredentialTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.ICredentialTypeEnum = {
    DEFAULT: 'DEFAULT',
    GATEWAY_API: 'GATEWAY_API',
    OPENVPN: 'OPENVPN',
    PPPOE_USERNAME: 'PPPOE_USERNAME',
    PPPOE_PASSWORD: 'PPPOE_PASSWORD',
    WIFI_PASSWORD: 'WIFI_PASSWORD'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IEventTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IWIFIChannelEnum = {
    CH149_20_MHZ: 'CH149_20MHZ',
    CH157_20_MHZ: 'CH157_20MHZ',
    CH163_20_MHZ: 'CH163_20MHZ'
};
/**
 * CredentialApi - axios parameter creator
 * @export
 */
var CredentialApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create credential.
         * @param {ICreateCredentialRequestDTO} [iCreateCredentialRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredential: function (iCreateCredentialRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/credential";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCredentialRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete credential by ID and type.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {ICredentialTypeEnum} credentialType Type of credential.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredentialByIDAndType: function (id, credentialType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCredentialByIDAndType', 'id', id);
                    // verify required parameter 'credentialType' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCredentialByIDAndType', 'credentialType', credentialType);
                    localVarPath = "/farm-infra/credential/{id}/{credentialType}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("credentialType", "}"), encodeURIComponent(String(credentialType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCredentials: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/credential";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all credentials by ID.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCredentialsByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getAllCredentialsByID', 'id', id);
                    localVarPath = "/farm-infra/credential/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all credentials by Type.
         * @param {ICredentialTypeEnum} credentialType type of credential.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCredentialsByType: function (credentialType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'credentialType' is not null or undefined
                    (0, common_1.assertParamExists)('getAllCredentialsByType', 'credentialType', credentialType);
                    localVarPath = "/farm-infra/credential/credential-type/{credentialType}"
                        .replace("{".concat("credentialType", "}"), encodeURIComponent(String(credentialType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get credential by ID and type.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {ICredentialTypeEnum} credentialType Type of credential.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredentialByIDAndType: function (id, credentialType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getCredentialByIDAndType', 'id', id);
                    // verify required parameter 'credentialType' is not null or undefined
                    (0, common_1.assertParamExists)('getCredentialByIDAndType', 'credentialType', credentialType);
                    localVarPath = "/farm-infra/credential/{id}/{credentialType}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("credentialType", "}"), encodeURIComponent(String(credentialType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update credential by ID and type.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {ICredentialTypeEnum} credentialType Type of credential.
         * @param {IUpdateCredentialRequestDTO} [iUpdateCredentialRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredentialByIDAndType: function (id, credentialType, iUpdateCredentialRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateCredentialByIDAndType', 'id', id);
                    // verify required parameter 'credentialType' is not null or undefined
                    (0, common_1.assertParamExists)('updateCredentialByIDAndType', 'credentialType', credentialType);
                    localVarPath = "/farm-infra/credential/{id}/{credentialType}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("credentialType", "}"), encodeURIComponent(String(credentialType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateCredentialRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CredentialApiAxiosParamCreator = CredentialApiAxiosParamCreator;
/**
 * CredentialApi - functional programming interface
 * @export
 */
var CredentialApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CredentialApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create credential.
         * @param {ICreateCredentialRequestDTO} [iCreateCredentialRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredential: function (iCreateCredentialRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCredential(iCreateCredentialRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete credential by ID and type.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {ICredentialTypeEnum} credentialType Type of credential.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredentialByIDAndType: function (id, credentialType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCredentialByIDAndType(id, credentialType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCredentials: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllCredentials(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all credentials by ID.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCredentialsByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllCredentialsByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all credentials by Type.
         * @param {ICredentialTypeEnum} credentialType type of credential.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCredentialsByType: function (credentialType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllCredentialsByType(credentialType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get credential by ID and type.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {ICredentialTypeEnum} credentialType Type of credential.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredentialByIDAndType: function (id, credentialType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCredentialByIDAndType(id, credentialType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update credential by ID and type.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {ICredentialTypeEnum} credentialType Type of credential.
         * @param {IUpdateCredentialRequestDTO} [iUpdateCredentialRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredentialByIDAndType: function (id, credentialType, iUpdateCredentialRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCredentialByIDAndType(id, credentialType, iUpdateCredentialRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CredentialApiFp = CredentialApiFp;
/**
 * CredentialApi - factory interface
 * @export
 */
var CredentialApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CredentialApiFp)(configuration);
    return {
        /**
         * Create credential.
         * @param {ICreateCredentialRequestDTO} [iCreateCredentialRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCredential: function (iCreateCredentialRequestDTO, options) {
            return localVarFp.createCredential(iCreateCredentialRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete credential by ID and type.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {ICredentialTypeEnum} credentialType Type of credential.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredentialByIDAndType: function (id, credentialType, options) {
            return localVarFp.deleteCredentialByIDAndType(id, credentialType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCredentials: function (options) {
            return localVarFp.getAllCredentials(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all credentials by ID.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCredentialsByID: function (id, options) {
            return localVarFp.getAllCredentialsByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all credentials by Type.
         * @param {ICredentialTypeEnum} credentialType type of credential.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCredentialsByType: function (credentialType, options) {
            return localVarFp.getAllCredentialsByType(credentialType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get credential by ID and type.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {ICredentialTypeEnum} credentialType Type of credential.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredentialByIDAndType: function (id, credentialType, options) {
            return localVarFp.getCredentialByIDAndType(id, credentialType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update credential by ID and type.
         * @param {string} id Unique ID of credential domain (device, farm, etc).
         * @param {ICredentialTypeEnum} credentialType Type of credential.
         * @param {IUpdateCredentialRequestDTO} [iUpdateCredentialRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredentialByIDAndType: function (id, credentialType, iUpdateCredentialRequestDTO, options) {
            return localVarFp.updateCredentialByIDAndType(id, credentialType, iUpdateCredentialRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CredentialApiFactory = CredentialApiFactory;
/**
 * CredentialApi - object-oriented interface
 * @export
 * @class CredentialApi
 * @extends {BaseAPI}
 */
var CredentialApi = /** @class */ (function (_super) {
    __extends(CredentialApi, _super);
    function CredentialApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create credential.
     * @param {ICreateCredentialRequestDTO} [iCreateCredentialRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialApi
     */
    CredentialApi.prototype.createCredential = function (iCreateCredentialRequestDTO, options) {
        var _this = this;
        return (0, exports.CredentialApiFp)(this.configuration).createCredential(iCreateCredentialRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete credential by ID and type.
     * @param {string} id Unique ID of credential domain (device, farm, etc).
     * @param {ICredentialTypeEnum} credentialType Type of credential.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialApi
     */
    CredentialApi.prototype.deleteCredentialByIDAndType = function (id, credentialType, options) {
        var _this = this;
        return (0, exports.CredentialApiFp)(this.configuration).deleteCredentialByIDAndType(id, credentialType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all credentials.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialApi
     */
    CredentialApi.prototype.getAllCredentials = function (options) {
        var _this = this;
        return (0, exports.CredentialApiFp)(this.configuration).getAllCredentials(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all credentials by ID.
     * @param {string} id Unique ID of credential domain (device, farm, etc).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialApi
     */
    CredentialApi.prototype.getAllCredentialsByID = function (id, options) {
        var _this = this;
        return (0, exports.CredentialApiFp)(this.configuration).getAllCredentialsByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all credentials by Type.
     * @param {ICredentialTypeEnum} credentialType type of credential.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialApi
     */
    CredentialApi.prototype.getAllCredentialsByType = function (credentialType, options) {
        var _this = this;
        return (0, exports.CredentialApiFp)(this.configuration).getAllCredentialsByType(credentialType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get credential by ID and type.
     * @param {string} id Unique ID of credential domain (device, farm, etc).
     * @param {ICredentialTypeEnum} credentialType Type of credential.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialApi
     */
    CredentialApi.prototype.getCredentialByIDAndType = function (id, credentialType, options) {
        var _this = this;
        return (0, exports.CredentialApiFp)(this.configuration).getCredentialByIDAndType(id, credentialType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update credential by ID and type.
     * @param {string} id Unique ID of credential domain (device, farm, etc).
     * @param {ICredentialTypeEnum} credentialType Type of credential.
     * @param {IUpdateCredentialRequestDTO} [iUpdateCredentialRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialApi
     */
    CredentialApi.prototype.updateCredentialByIDAndType = function (id, credentialType, iUpdateCredentialRequestDTO, options) {
        var _this = this;
        return (0, exports.CredentialApiFp)(this.configuration).updateCredentialByIDAndType(id, credentialType, iUpdateCredentialRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CredentialApi;
}(base_1.BaseAPI));
exports.CredentialApi = CredentialApi;
/**
 * DeviceApi - axios parameter creator
 * @export
 */
var DeviceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create device.
         * @param {ICreateDeviceRequestDTO} [iCreateDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevice: function (iCreateDeviceRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateDeviceRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete device by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceByIDAndFarmID: function (id, farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteDeviceByIDAndFarmID', 'id', id);
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteDeviceByIDAndFarmID', 'farmId', farmId);
                    localVarPath = "/farm-infra/device/{id}/{farmId}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all device metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceMetadata: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/device/metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all device metadata by shard ID.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceMetadataByShardID: function (shardId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shardId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllDeviceMetadataByShardID', 'shardId', shardId);
                    localVarPath = "/farm-infra/device/metadata/shard/{shardId}"
                        .replace("{".concat("shardId", "}"), encodeURIComponent(String(shardId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevices: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all devices by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllDevicesByFarmID', 'farmId', farmId);
                    localVarPath = "/farm-infra/device/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all devices by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getAllDevicesByID', 'id', id);
                    localVarPath = "/farm-infra/device/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all devices by shard ID.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesByShardID: function (shardId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shardId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllDevicesByShardID', 'shardId', shardId);
                    localVarPath = "/farm-infra/device/shard/{shardId}"
                        .replace("{".concat("shardId", "}"), encodeURIComponent(String(shardId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get device by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceByIDAndFarmID: function (id, farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getDeviceByIDAndFarmID', 'id', id);
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getDeviceByIDAndFarmID', 'farmId', farmId);
                    localVarPath = "/farm-infra/device/{id}/{farmId}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceMetadataByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getDeviceMetadataByID', 'id', id);
                    localVarPath = "/farm-infra/device/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update device by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateDeviceRequestDTO} [iUpdateDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceByIDAndFarmID: function (id, farmId, iUpdateDeviceRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceByIDAndFarmID', 'id', id);
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceByIDAndFarmID', 'farmId', farmId);
                    localVarPath = "/farm-infra/device/{id}/{farmId}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateDeviceRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {IUpdateDeviceMetadataRequestDTO} [iUpdateDeviceMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceMetadataByID: function (id, iUpdateDeviceMetadataRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceMetadataByID', 'id', id);
                    localVarPath = "/farm-infra/device/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateDeviceMetadataRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceApiAxiosParamCreator = DeviceApiAxiosParamCreator;
/**
 * DeviceApi - functional programming interface
 * @export
 */
var DeviceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create device.
         * @param {ICreateDeviceRequestDTO} [iCreateDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevice: function (iCreateDeviceRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDevice(iCreateDeviceRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete device by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceByIDAndFarmID: function (id, farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDeviceByIDAndFarmID(id, farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all device metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceMetadata: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDeviceMetadata(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all device metadata by shard ID.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceMetadataByShardID: function (shardId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDeviceMetadataByShardID(shardId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevices: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDevices(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all devices by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDevicesByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all devices by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDevicesByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all devices by shard ID.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesByShardID: function (shardId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDevicesByShardID(shardId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get device by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceByIDAndFarmID: function (id, farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceByIDAndFarmID(id, farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceMetadataByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceMetadataByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update device by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateDeviceRequestDTO} [iUpdateDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceByIDAndFarmID: function (id, farmId, iUpdateDeviceRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceByIDAndFarmID(id, farmId, iUpdateDeviceRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {IUpdateDeviceMetadataRequestDTO} [iUpdateDeviceMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceMetadataByID: function (id, iUpdateDeviceMetadataRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceMetadataByID(id, iUpdateDeviceMetadataRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceApiFp = DeviceApiFp;
/**
 * DeviceApi - factory interface
 * @export
 */
var DeviceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceApiFp)(configuration);
    return {
        /**
         * Create device.
         * @param {ICreateDeviceRequestDTO} [iCreateDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevice: function (iCreateDeviceRequestDTO, options) {
            return localVarFp.createDevice(iCreateDeviceRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete device by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceByIDAndFarmID: function (id, farmId, options) {
            return localVarFp.deleteDeviceByIDAndFarmID(id, farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all device metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceMetadata: function (options) {
            return localVarFp.getAllDeviceMetadata(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all device metadata by shard ID.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceMetadataByShardID: function (shardId, options) {
            return localVarFp.getAllDeviceMetadataByShardID(shardId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevices: function (options) {
            return localVarFp.getAllDevices(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all devices by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesByFarmID: function (farmId, options) {
            return localVarFp.getAllDevicesByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all devices by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesByID: function (id, options) {
            return localVarFp.getAllDevicesByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all devices by shard ID.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevicesByShardID: function (shardId, options) {
            return localVarFp.getAllDevicesByShardID(shardId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get device by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceByIDAndFarmID: function (id, farmId, options) {
            return localVarFp.getDeviceByIDAndFarmID(id, farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceMetadataByID: function (id, options) {
            return localVarFp.getDeviceMetadataByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update device by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateDeviceRequestDTO} [iUpdateDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceByIDAndFarmID: function (id, farmId, iUpdateDeviceRequestDTO, options) {
            return localVarFp.updateDeviceByIDAndFarmID(id, farmId, iUpdateDeviceRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {IUpdateDeviceMetadataRequestDTO} [iUpdateDeviceMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceMetadataByID: function (id, iUpdateDeviceMetadataRequestDTO, options) {
            return localVarFp.updateDeviceMetadataByID(id, iUpdateDeviceMetadataRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceApiFactory = DeviceApiFactory;
/**
 * DeviceApi - object-oriented interface
 * @export
 * @class DeviceApi
 * @extends {BaseAPI}
 */
var DeviceApi = /** @class */ (function (_super) {
    __extends(DeviceApi, _super);
    function DeviceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create device.
     * @param {ICreateDeviceRequestDTO} [iCreateDeviceRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.createDevice = function (iCreateDeviceRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).createDevice(iCreateDeviceRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete device by ID and farm ID.
     * @param {string} id Unique ID of device.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.deleteDeviceByIDAndFarmID = function (id, farmId, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).deleteDeviceByIDAndFarmID(id, farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all device metadata.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getAllDeviceMetadata = function (options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getAllDeviceMetadata(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all device metadata by shard ID.
     * @param {string} shardId Unique ID of shard.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getAllDeviceMetadataByShardID = function (shardId, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getAllDeviceMetadataByShardID(shardId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all devices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getAllDevices = function (options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getAllDevices(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all devices by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getAllDevicesByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getAllDevicesByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all devices by ID.
     * @param {string} id Unique ID of device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getAllDevicesByID = function (id, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getAllDevicesByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all devices by shard ID.
     * @param {string} shardId Unique ID of shard.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getAllDevicesByShardID = function (shardId, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getAllDevicesByShardID(shardId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get device by ID and farm ID.
     * @param {string} id Unique ID of device.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getDeviceByIDAndFarmID = function (id, farmId, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getDeviceByIDAndFarmID(id, farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get device metadata by ID.
     * @param {string} id Unique ID of device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.getDeviceMetadataByID = function (id, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).getDeviceMetadataByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update device by ID and farm ID.
     * @param {string} id Unique ID of device.
     * @param {string} farmId Unique ID of farm.
     * @param {IUpdateDeviceRequestDTO} [iUpdateDeviceRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.updateDeviceByIDAndFarmID = function (id, farmId, iUpdateDeviceRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).updateDeviceByIDAndFarmID(id, farmId, iUpdateDeviceRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update device metadata by ID.
     * @param {string} id Unique ID of device.
     * @param {IUpdateDeviceMetadataRequestDTO} [iUpdateDeviceMetadataRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    DeviceApi.prototype.updateDeviceMetadataByID = function (id, iUpdateDeviceMetadataRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceApiFp)(this.configuration).updateDeviceMetadataByID(id, iUpdateDeviceMetadataRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceApi;
}(base_1.BaseAPI));
exports.DeviceApi = DeviceApi;
/**
 * FarmApi - axios parameter creator
 * @export
 */
var FarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create farm.
         * @param {ICreateFarmRequestDTO} [iCreateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarm: function (iCreateFarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/farm";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateFarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFarmByID', 'id', id);
                    localVarPath = "/farm-infra/farm/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all farm metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmMetadata: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/farm/metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all farms.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarms: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/farm";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all farms by shard ID.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmsByShardID: function (shardId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shardId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllFarmsByShardID', 'shardId', shardId);
                    localVarPath = "/farm-infra/farm/shard/{shardId}"
                        .replace("{".concat("shardId", "}"), encodeURIComponent(String(shardId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmByID', 'id', id);
                    localVarPath = "/farm-infra/farm/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmMetadataByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmMetadataByID', 'id', id);
                    localVarPath = "/farm-infra/farm/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmRequestDTO} [iUpdateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmByID: function (id, iUpdateFarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmByID', 'id', id);
                    localVarPath = "/farm-infra/farm/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmMetadataRequestDTO} [iUpdateFarmMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmMetadataByID: function (id, iUpdateFarmMetadataRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmMetadataByID', 'id', id);
                    localVarPath = "/farm-infra/farm/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmMetadataRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmApiAxiosParamCreator = FarmApiAxiosParamCreator;
/**
 * FarmApi - functional programming interface
 * @export
 */
var FarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create farm.
         * @param {ICreateFarmRequestDTO} [iCreateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarm: function (iCreateFarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFarm(iCreateFarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFarmByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all farm metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmMetadata: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFarmMetadata(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all farms.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarms: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFarms(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all farms by shard ID.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmsByShardID: function (shardId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFarmsByShardID(shardId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmMetadataByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmMetadataByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmRequestDTO} [iUpdateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmByID: function (id, iUpdateFarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmByID(id, iUpdateFarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmMetadataRequestDTO} [iUpdateFarmMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmMetadataByID: function (id, iUpdateFarmMetadataRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmMetadataByID(id, iUpdateFarmMetadataRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmApiFp = FarmApiFp;
/**
 * FarmApi - factory interface
 * @export
 */
var FarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmApiFp)(configuration);
    return {
        /**
         * Create farm.
         * @param {ICreateFarmRequestDTO} [iCreateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarm: function (iCreateFarmRequestDTO, options) {
            return localVarFp.createFarm(iCreateFarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmByID: function (id, options) {
            return localVarFp.deleteFarmByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all farm metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmMetadata: function (options) {
            return localVarFp.getAllFarmMetadata(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all farms.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarms: function (options) {
            return localVarFp.getAllFarms(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all farms by shard ID.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarmsByShardID: function (shardId, options) {
            return localVarFp.getAllFarmsByShardID(shardId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmByID: function (id, options) {
            return localVarFp.getFarmByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmMetadataByID: function (id, options) {
            return localVarFp.getFarmMetadataByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmRequestDTO} [iUpdateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmByID: function (id, iUpdateFarmRequestDTO, options) {
            return localVarFp.updateFarmByID(id, iUpdateFarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update farm metadata by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmMetadataRequestDTO} [iUpdateFarmMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmMetadataByID: function (id, iUpdateFarmMetadataRequestDTO, options) {
            return localVarFp.updateFarmMetadataByID(id, iUpdateFarmMetadataRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmApiFactory = FarmApiFactory;
/**
 * FarmApi - object-oriented interface
 * @export
 * @class FarmApi
 * @extends {BaseAPI}
 */
var FarmApi = /** @class */ (function (_super) {
    __extends(FarmApi, _super);
    function FarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create farm.
     * @param {ICreateFarmRequestDTO} [iCreateFarmRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.createFarm = function (iCreateFarmRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).createFarm(iCreateFarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete farm by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.deleteFarmByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).deleteFarmByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all farm metadata.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getAllFarmMetadata = function (options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getAllFarmMetadata(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all farms.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getAllFarms = function (options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getAllFarms(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all farms by shard ID.
     * @param {string} shardId Unique ID of shard.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getAllFarmsByShardID = function (shardId, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getAllFarmsByShardID(shardId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get farm by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getFarmByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getFarmByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get farm metadata by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getFarmMetadataByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getFarmMetadataByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update farm by ID.
     * @param {string} id Unique ID of farm.
     * @param {IUpdateFarmRequestDTO} [iUpdateFarmRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.updateFarmByID = function (id, iUpdateFarmRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).updateFarmByID(id, iUpdateFarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update farm metadata by ID.
     * @param {string} id Unique ID of farm.
     * @param {IUpdateFarmMetadataRequestDTO} [iUpdateFarmMetadataRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.updateFarmMetadataByID = function (id, iUpdateFarmMetadataRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).updateFarmMetadataByID(id, iUpdateFarmMetadataRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmApi;
}(base_1.BaseAPI));
exports.FarmApi = FarmApi;
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
var HealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/health-check";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthCheckApiAxiosParamCreator = HealthCheckApiAxiosParamCreator;
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
var HealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthCheckApiFp = HealthCheckApiFp;
/**
 * HealthCheckApi - factory interface
 * @export
 */
var HealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthCheckApiFp)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return localVarFp.checkHealth(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthCheckApiFactory = HealthCheckApiFactory;
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    __extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Check service health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.checkHealth = function (options) {
        var _this = this;
        return (0, exports.HealthCheckApiFp)(this.configuration).checkHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthCheckApi;
}(base_1.BaseAPI));
exports.HealthCheckApi = HealthCheckApi;
/**
 * NetworkDeviceApi - axios parameter creator
 * @export
 */
var NetworkDeviceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create network device.
         * @param {ICreateNetworkDeviceRequestDTO} [iCreateNetworkDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkDevice: function (iCreateNetworkDeviceRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/network-device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateNetworkDeviceRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete network device by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkDeviceByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteNetworkDeviceByID', 'id', id);
                    localVarPath = "/farm-infra/network-device/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network device metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceMetadata: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/network-device/metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDevices: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/network-device";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network devices by network group ID.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDevicesByNetworkGroupID: function (networkGroupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'networkGroupId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllNetworkDevicesByNetworkGroupID', 'networkGroupId', networkGroupId);
                    localVarPath = "/farm-infra/network-device/network-group/{networkGroupId}"
                        .replace("{".concat("networkGroupId", "}"), encodeURIComponent(String(networkGroupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get network device by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkDeviceByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getNetworkDeviceByID', 'id', id);
                    localVarPath = "/farm-infra/network-device/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get network device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkDeviceMetadataByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getNetworkDeviceMetadataByID', 'id', id);
                    localVarPath = "/farm-infra/network-device/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update network device by ID.
         * @param {string} id Unique ID of network device.
         * @param {IUpdateNetworkDeviceRequestDTO} [iUpdateNetworkDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkDeviceByID: function (id, iUpdateNetworkDeviceRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateNetworkDeviceByID', 'id', id);
                    localVarPath = "/farm-infra/network-device/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateNetworkDeviceRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update network device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {IUpdateNetworkDeviceMetadataRequestDTO} [iUpdateNetworkDeviceMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkDeviceMetadataByID: function (id, iUpdateNetworkDeviceMetadataRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateNetworkDeviceMetadataByID', 'id', id);
                    localVarPath = "/farm-infra/network-device/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateNetworkDeviceMetadataRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.NetworkDeviceApiAxiosParamCreator = NetworkDeviceApiAxiosParamCreator;
/**
 * NetworkDeviceApi - functional programming interface
 * @export
 */
var NetworkDeviceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NetworkDeviceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create network device.
         * @param {ICreateNetworkDeviceRequestDTO} [iCreateNetworkDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkDevice: function (iCreateNetworkDeviceRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createNetworkDevice(iCreateNetworkDeviceRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete network device by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkDeviceByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteNetworkDeviceByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network device metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceMetadata: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkDeviceMetadata(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDevices: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkDevices(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network devices by network group ID.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDevicesByNetworkGroupID: function (networkGroupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkDevicesByNetworkGroupID(networkGroupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get network device by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkDeviceByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNetworkDeviceByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get network device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkDeviceMetadataByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNetworkDeviceMetadataByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update network device by ID.
         * @param {string} id Unique ID of network device.
         * @param {IUpdateNetworkDeviceRequestDTO} [iUpdateNetworkDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkDeviceByID: function (id, iUpdateNetworkDeviceRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateNetworkDeviceByID(id, iUpdateNetworkDeviceRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update network device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {IUpdateNetworkDeviceMetadataRequestDTO} [iUpdateNetworkDeviceMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkDeviceMetadataByID: function (id, iUpdateNetworkDeviceMetadataRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateNetworkDeviceMetadataByID(id, iUpdateNetworkDeviceMetadataRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.NetworkDeviceApiFp = NetworkDeviceApiFp;
/**
 * NetworkDeviceApi - factory interface
 * @export
 */
var NetworkDeviceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NetworkDeviceApiFp)(configuration);
    return {
        /**
         * Create network device.
         * @param {ICreateNetworkDeviceRequestDTO} [iCreateNetworkDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkDevice: function (iCreateNetworkDeviceRequestDTO, options) {
            return localVarFp.createNetworkDevice(iCreateNetworkDeviceRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete network device by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkDeviceByID: function (id, options) {
            return localVarFp.deleteNetworkDeviceByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network device metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceMetadata: function (options) {
            return localVarFp.getAllNetworkDeviceMetadata(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network devices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDevices: function (options) {
            return localVarFp.getAllNetworkDevices(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network devices by network group ID.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDevicesByNetworkGroupID: function (networkGroupId, options) {
            return localVarFp.getAllNetworkDevicesByNetworkGroupID(networkGroupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get network device by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkDeviceByID: function (id, options) {
            return localVarFp.getNetworkDeviceByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get network device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkDeviceMetadataByID: function (id, options) {
            return localVarFp.getNetworkDeviceMetadataByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update network device by ID.
         * @param {string} id Unique ID of network device.
         * @param {IUpdateNetworkDeviceRequestDTO} [iUpdateNetworkDeviceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkDeviceByID: function (id, iUpdateNetworkDeviceRequestDTO, options) {
            return localVarFp.updateNetworkDeviceByID(id, iUpdateNetworkDeviceRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update network device metadata by ID.
         * @param {string} id Unique ID of device.
         * @param {IUpdateNetworkDeviceMetadataRequestDTO} [iUpdateNetworkDeviceMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkDeviceMetadataByID: function (id, iUpdateNetworkDeviceMetadataRequestDTO, options) {
            return localVarFp.updateNetworkDeviceMetadataByID(id, iUpdateNetworkDeviceMetadataRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NetworkDeviceApiFactory = NetworkDeviceApiFactory;
/**
 * NetworkDeviceApi - object-oriented interface
 * @export
 * @class NetworkDeviceApi
 * @extends {BaseAPI}
 */
var NetworkDeviceApi = /** @class */ (function (_super) {
    __extends(NetworkDeviceApi, _super);
    function NetworkDeviceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create network device.
     * @param {ICreateNetworkDeviceRequestDTO} [iCreateNetworkDeviceRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceApi
     */
    NetworkDeviceApi.prototype.createNetworkDevice = function (iCreateNetworkDeviceRequestDTO, options) {
        var _this = this;
        return (0, exports.NetworkDeviceApiFp)(this.configuration).createNetworkDevice(iCreateNetworkDeviceRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete network device by ID.
     * @param {string} id Unique ID of network device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceApi
     */
    NetworkDeviceApi.prototype.deleteNetworkDeviceByID = function (id, options) {
        var _this = this;
        return (0, exports.NetworkDeviceApiFp)(this.configuration).deleteNetworkDeviceByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network device metadata.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceApi
     */
    NetworkDeviceApi.prototype.getAllNetworkDeviceMetadata = function (options) {
        var _this = this;
        return (0, exports.NetworkDeviceApiFp)(this.configuration).getAllNetworkDeviceMetadata(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network devices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceApi
     */
    NetworkDeviceApi.prototype.getAllNetworkDevices = function (options) {
        var _this = this;
        return (0, exports.NetworkDeviceApiFp)(this.configuration).getAllNetworkDevices(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network devices by network group ID.
     * @param {string} networkGroupId Unique ID of network group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceApi
     */
    NetworkDeviceApi.prototype.getAllNetworkDevicesByNetworkGroupID = function (networkGroupId, options) {
        var _this = this;
        return (0, exports.NetworkDeviceApiFp)(this.configuration).getAllNetworkDevicesByNetworkGroupID(networkGroupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get network device by ID.
     * @param {string} id Unique ID of network device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceApi
     */
    NetworkDeviceApi.prototype.getNetworkDeviceByID = function (id, options) {
        var _this = this;
        return (0, exports.NetworkDeviceApiFp)(this.configuration).getNetworkDeviceByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get network device metadata by ID.
     * @param {string} id Unique ID of device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceApi
     */
    NetworkDeviceApi.prototype.getNetworkDeviceMetadataByID = function (id, options) {
        var _this = this;
        return (0, exports.NetworkDeviceApiFp)(this.configuration).getNetworkDeviceMetadataByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update network device by ID.
     * @param {string} id Unique ID of network device.
     * @param {IUpdateNetworkDeviceRequestDTO} [iUpdateNetworkDeviceRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceApi
     */
    NetworkDeviceApi.prototype.updateNetworkDeviceByID = function (id, iUpdateNetworkDeviceRequestDTO, options) {
        var _this = this;
        return (0, exports.NetworkDeviceApiFp)(this.configuration).updateNetworkDeviceByID(id, iUpdateNetworkDeviceRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update network device metadata by ID.
     * @param {string} id Unique ID of device.
     * @param {IUpdateNetworkDeviceMetadataRequestDTO} [iUpdateNetworkDeviceMetadataRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceApi
     */
    NetworkDeviceApi.prototype.updateNetworkDeviceMetadataByID = function (id, iUpdateNetworkDeviceMetadataRequestDTO, options) {
        var _this = this;
        return (0, exports.NetworkDeviceApiFp)(this.configuration).updateNetworkDeviceMetadataByID(id, iUpdateNetworkDeviceMetadataRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NetworkDeviceApi;
}(base_1.BaseAPI));
exports.NetworkDeviceApi = NetworkDeviceApi;
/**
 * NetworkGroupApi - axios parameter creator
 * @export
 */
var NetworkGroupApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkGroup: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/network-group";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create network group farm mapping.
         * @param {ICreateNetworkGroupFarmMappingRequestDTO} [iCreateNetworkGroupFarmMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkGroupFarmMapping: function (iCreateNetworkGroupFarmMappingRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/network-group/mapping";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateNetworkGroupFarmMappingRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete network group by ID.
         * @param {string} id Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkGroupByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteNetworkGroupByID', 'id', id);
                    localVarPath = "/farm-infra/network-group/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete network group farm mapping by farm id and network group id.
         * @param {string} farmId Unique ID of farm.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkGroupFarmMappingByFarmIDAndNetworkID: function (farmId, networkGroupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteNetworkGroupFarmMappingByFarmIDAndNetworkID', 'farmId', farmId);
                    // verify required parameter 'networkGroupId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteNetworkGroupFarmMappingByFarmIDAndNetworkID', 'networkGroupId', networkGroupId);
                    localVarPath = "/farm-infra/network-group/mapping/{farmId}/{networkGroupId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)))
                        .replace("{".concat("networkGroupId", "}"), encodeURIComponent(String(networkGroupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network group farm mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupFarmMappings: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/network-group/mapping";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network group farm mappings by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupFarmMappingsByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllNetworkGroupFarmMappingsByFarmID', 'farmId', farmId);
                    localVarPath = "/farm-infra/network-group/mapping/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network group farm mappings by network group id.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupFarmMappingsByNetworkGroupID: function (networkGroupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'networkGroupId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllNetworkGroupFarmMappingsByNetworkGroupID', 'networkGroupId', networkGroupId);
                    localVarPath = "/farm-infra/network-group/mapping/network-group/{networkGroupId}"
                        .replace("{".concat("networkGroupId", "}"), encodeURIComponent(String(networkGroupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network groups metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupMetadata: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/network-group/metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroups: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/network-group";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get network group by ID.
         * @param {string} id Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkGroupByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getNetworkGroupByID', 'id', id);
                    localVarPath = "/farm-infra/network-group/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get network group farm mapping by farm id and network group id.
         * @param {string} farmId Unique ID of farm.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkGroupFarmMappingByFarmIDAndNetworkID: function (farmId, networkGroupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getNetworkGroupFarmMappingByFarmIDAndNetworkID', 'farmId', farmId);
                    // verify required parameter 'networkGroupId' is not null or undefined
                    (0, common_1.assertParamExists)('getNetworkGroupFarmMappingByFarmIDAndNetworkID', 'networkGroupId', networkGroupId);
                    localVarPath = "/farm-infra/network-group/mapping/{farmId}/{networkGroupId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)))
                        .replace("{".concat("networkGroupId", "}"), encodeURIComponent(String(networkGroupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get network group metadata by ID.
         * @param {string} id Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkGroupMetadataByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getNetworkGroupMetadataByID', 'id', id);
                    localVarPath = "/farm-infra/network-group/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update network group by ID.
         * @param {string} id Unique ID of network group.
         * @param {IUpdateNetworkGroupRequestDTO} [iUpdateNetworkGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkGroupByID: function (id, iUpdateNetworkGroupRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateNetworkGroupByID', 'id', id);
                    localVarPath = "/farm-infra/network-group/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateNetworkGroupRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update network group metadata by ID.
         * @param {string} id Unique ID of network group.
         * @param {IUpdateNetworkGroupMetadataRequestDTO} [iUpdateNetworkGroupMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkGroupMetadataByID: function (id, iUpdateNetworkGroupMetadataRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateNetworkGroupMetadataByID', 'id', id);
                    localVarPath = "/farm-infra/network-group/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateNetworkGroupMetadataRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.NetworkGroupApiAxiosParamCreator = NetworkGroupApiAxiosParamCreator;
/**
 * NetworkGroupApi - functional programming interface
 * @export
 */
var NetworkGroupApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NetworkGroupApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkGroup: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createNetworkGroup(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create network group farm mapping.
         * @param {ICreateNetworkGroupFarmMappingRequestDTO} [iCreateNetworkGroupFarmMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkGroupFarmMapping: function (iCreateNetworkGroupFarmMappingRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createNetworkGroupFarmMapping(iCreateNetworkGroupFarmMappingRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete network group by ID.
         * @param {string} id Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkGroupByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteNetworkGroupByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete network group farm mapping by farm id and network group id.
         * @param {string} farmId Unique ID of farm.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkGroupFarmMappingByFarmIDAndNetworkID: function (farmId, networkGroupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteNetworkGroupFarmMappingByFarmIDAndNetworkID(farmId, networkGroupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network group farm mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupFarmMappings: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkGroupFarmMappings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network group farm mappings by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupFarmMappingsByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkGroupFarmMappingsByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network group farm mappings by network group id.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupFarmMappingsByNetworkGroupID: function (networkGroupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkGroupFarmMappingsByNetworkGroupID(networkGroupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network groups metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupMetadata: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkGroupMetadata(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroups: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkGroups(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get network group by ID.
         * @param {string} id Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkGroupByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNetworkGroupByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get network group farm mapping by farm id and network group id.
         * @param {string} farmId Unique ID of farm.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkGroupFarmMappingByFarmIDAndNetworkID: function (farmId, networkGroupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNetworkGroupFarmMappingByFarmIDAndNetworkID(farmId, networkGroupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get network group metadata by ID.
         * @param {string} id Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkGroupMetadataByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNetworkGroupMetadataByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update network group by ID.
         * @param {string} id Unique ID of network group.
         * @param {IUpdateNetworkGroupRequestDTO} [iUpdateNetworkGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkGroupByID: function (id, iUpdateNetworkGroupRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateNetworkGroupByID(id, iUpdateNetworkGroupRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update network group metadata by ID.
         * @param {string} id Unique ID of network group.
         * @param {IUpdateNetworkGroupMetadataRequestDTO} [iUpdateNetworkGroupMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkGroupMetadataByID: function (id, iUpdateNetworkGroupMetadataRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateNetworkGroupMetadataByID(id, iUpdateNetworkGroupMetadataRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.NetworkGroupApiFp = NetworkGroupApiFp;
/**
 * NetworkGroupApi - factory interface
 * @export
 */
var NetworkGroupApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NetworkGroupApiFp)(configuration);
    return {
        /**
         * Create network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkGroup: function (options) {
            return localVarFp.createNetworkGroup(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create network group farm mapping.
         * @param {ICreateNetworkGroupFarmMappingRequestDTO} [iCreateNetworkGroupFarmMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkGroupFarmMapping: function (iCreateNetworkGroupFarmMappingRequestDTO, options) {
            return localVarFp.createNetworkGroupFarmMapping(iCreateNetworkGroupFarmMappingRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete network group by ID.
         * @param {string} id Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkGroupByID: function (id, options) {
            return localVarFp.deleteNetworkGroupByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete network group farm mapping by farm id and network group id.
         * @param {string} farmId Unique ID of farm.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkGroupFarmMappingByFarmIDAndNetworkID: function (farmId, networkGroupId, options) {
            return localVarFp.deleteNetworkGroupFarmMappingByFarmIDAndNetworkID(farmId, networkGroupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network group farm mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupFarmMappings: function (options) {
            return localVarFp.getAllNetworkGroupFarmMappings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network group farm mappings by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupFarmMappingsByFarmID: function (farmId, options) {
            return localVarFp.getAllNetworkGroupFarmMappingsByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network group farm mappings by network group id.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupFarmMappingsByNetworkGroupID: function (networkGroupId, options) {
            return localVarFp.getAllNetworkGroupFarmMappingsByNetworkGroupID(networkGroupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network groups metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroupMetadata: function (options) {
            return localVarFp.getAllNetworkGroupMetadata(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkGroups: function (options) {
            return localVarFp.getAllNetworkGroups(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get network group by ID.
         * @param {string} id Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkGroupByID: function (id, options) {
            return localVarFp.getNetworkGroupByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get network group farm mapping by farm id and network group id.
         * @param {string} farmId Unique ID of farm.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkGroupFarmMappingByFarmIDAndNetworkID: function (farmId, networkGroupId, options) {
            return localVarFp.getNetworkGroupFarmMappingByFarmIDAndNetworkID(farmId, networkGroupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get network group metadata by ID.
         * @param {string} id Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkGroupMetadataByID: function (id, options) {
            return localVarFp.getNetworkGroupMetadataByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update network group by ID.
         * @param {string} id Unique ID of network group.
         * @param {IUpdateNetworkGroupRequestDTO} [iUpdateNetworkGroupRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkGroupByID: function (id, iUpdateNetworkGroupRequestDTO, options) {
            return localVarFp.updateNetworkGroupByID(id, iUpdateNetworkGroupRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update network group metadata by ID.
         * @param {string} id Unique ID of network group.
         * @param {IUpdateNetworkGroupMetadataRequestDTO} [iUpdateNetworkGroupMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkGroupMetadataByID: function (id, iUpdateNetworkGroupMetadataRequestDTO, options) {
            return localVarFp.updateNetworkGroupMetadataByID(id, iUpdateNetworkGroupMetadataRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NetworkGroupApiFactory = NetworkGroupApiFactory;
/**
 * NetworkGroupApi - object-oriented interface
 * @export
 * @class NetworkGroupApi
 * @extends {BaseAPI}
 */
var NetworkGroupApi = /** @class */ (function (_super) {
    __extends(NetworkGroupApi, _super);
    function NetworkGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create network group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.createNetworkGroup = function (options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).createNetworkGroup(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create network group farm mapping.
     * @param {ICreateNetworkGroupFarmMappingRequestDTO} [iCreateNetworkGroupFarmMappingRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.createNetworkGroupFarmMapping = function (iCreateNetworkGroupFarmMappingRequestDTO, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).createNetworkGroupFarmMapping(iCreateNetworkGroupFarmMappingRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete network group by ID.
     * @param {string} id Unique ID of network group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.deleteNetworkGroupByID = function (id, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).deleteNetworkGroupByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete network group farm mapping by farm id and network group id.
     * @param {string} farmId Unique ID of farm.
     * @param {string} networkGroupId Unique ID of network group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.deleteNetworkGroupFarmMappingByFarmIDAndNetworkID = function (farmId, networkGroupId, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).deleteNetworkGroupFarmMappingByFarmIDAndNetworkID(farmId, networkGroupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network group farm mappings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.getAllNetworkGroupFarmMappings = function (options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).getAllNetworkGroupFarmMappings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network group farm mappings by farm id.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.getAllNetworkGroupFarmMappingsByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).getAllNetworkGroupFarmMappingsByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network group farm mappings by network group id.
     * @param {string} networkGroupId Unique ID of network group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.getAllNetworkGroupFarmMappingsByNetworkGroupID = function (networkGroupId, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).getAllNetworkGroupFarmMappingsByNetworkGroupID(networkGroupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network groups metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.getAllNetworkGroupMetadata = function (options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).getAllNetworkGroupMetadata(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network groups.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.getAllNetworkGroups = function (options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).getAllNetworkGroups(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get network group by ID.
     * @param {string} id Unique ID of network group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.getNetworkGroupByID = function (id, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).getNetworkGroupByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get network group farm mapping by farm id and network group id.
     * @param {string} farmId Unique ID of farm.
     * @param {string} networkGroupId Unique ID of network group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.getNetworkGroupFarmMappingByFarmIDAndNetworkID = function (farmId, networkGroupId, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).getNetworkGroupFarmMappingByFarmIDAndNetworkID(farmId, networkGroupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get network group metadata by ID.
     * @param {string} id Unique ID of network group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.getNetworkGroupMetadataByID = function (id, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).getNetworkGroupMetadataByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update network group by ID.
     * @param {string} id Unique ID of network group.
     * @param {IUpdateNetworkGroupRequestDTO} [iUpdateNetworkGroupRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.updateNetworkGroupByID = function (id, iUpdateNetworkGroupRequestDTO, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).updateNetworkGroupByID(id, iUpdateNetworkGroupRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update network group metadata by ID.
     * @param {string} id Unique ID of network group.
     * @param {IUpdateNetworkGroupMetadataRequestDTO} [iUpdateNetworkGroupMetadataRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGroupApi
     */
    NetworkGroupApi.prototype.updateNetworkGroupMetadataByID = function (id, iUpdateNetworkGroupMetadataRequestDTO, options) {
        var _this = this;
        return (0, exports.NetworkGroupApiFp)(this.configuration).updateNetworkGroupMetadataByID(id, iUpdateNetworkGroupMetadataRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NetworkGroupApi;
}(base_1.BaseAPI));
exports.NetworkGroupApi = NetworkGroupApi;
/**
 * ShardApi - axios parameter creator
 * @export
 */
var ShardApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create shard.
         * @param {ICreateShardRequestDTO} [iCreateShardRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShard: function (iCreateShardRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/shard";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateShardRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete shard by ID.
         * @param {string} id Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShardByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteShardByID', 'id', id);
                    localVarPath = "/farm-infra/shard/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all shards.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllShards: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/shard";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get shard by ID.
         * @param {string} id Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShardByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getShardByID', 'id', id);
                    localVarPath = "/farm-infra/shard/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update shard by ID.
         * @param {string} id Unique ID of shard.
         * @param {IUpdateShardRequestDTO} [iUpdateShardRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShardByID: function (id, iUpdateShardRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateShardByID', 'id', id);
                    localVarPath = "/farm-infra/shard/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateShardRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ShardApiAxiosParamCreator = ShardApiAxiosParamCreator;
/**
 * ShardApi - functional programming interface
 * @export
 */
var ShardApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShardApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create shard.
         * @param {ICreateShardRequestDTO} [iCreateShardRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShard: function (iCreateShardRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createShard(iCreateShardRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete shard by ID.
         * @param {string} id Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShardByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteShardByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all shards.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllShards: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllShards(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get shard by ID.
         * @param {string} id Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShardByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getShardByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update shard by ID.
         * @param {string} id Unique ID of shard.
         * @param {IUpdateShardRequestDTO} [iUpdateShardRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShardByID: function (id, iUpdateShardRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShardByID(id, iUpdateShardRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShardApiFp = ShardApiFp;
/**
 * ShardApi - factory interface
 * @export
 */
var ShardApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShardApiFp)(configuration);
    return {
        /**
         * Create shard.
         * @param {ICreateShardRequestDTO} [iCreateShardRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShard: function (iCreateShardRequestDTO, options) {
            return localVarFp.createShard(iCreateShardRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete shard by ID.
         * @param {string} id Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShardByID: function (id, options) {
            return localVarFp.deleteShardByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all shards.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllShards: function (options) {
            return localVarFp.getAllShards(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get shard by ID.
         * @param {string} id Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShardByID: function (id, options) {
            return localVarFp.getShardByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update shard by ID.
         * @param {string} id Unique ID of shard.
         * @param {IUpdateShardRequestDTO} [iUpdateShardRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShardByID: function (id, iUpdateShardRequestDTO, options) {
            return localVarFp.updateShardByID(id, iUpdateShardRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShardApiFactory = ShardApiFactory;
/**
 * ShardApi - object-oriented interface
 * @export
 * @class ShardApi
 * @extends {BaseAPI}
 */
var ShardApi = /** @class */ (function (_super) {
    __extends(ShardApi, _super);
    function ShardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create shard.
     * @param {ICreateShardRequestDTO} [iCreateShardRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShardApi
     */
    ShardApi.prototype.createShard = function (iCreateShardRequestDTO, options) {
        var _this = this;
        return (0, exports.ShardApiFp)(this.configuration).createShard(iCreateShardRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete shard by ID.
     * @param {string} id Unique ID of shard.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShardApi
     */
    ShardApi.prototype.deleteShardByID = function (id, options) {
        var _this = this;
        return (0, exports.ShardApiFp)(this.configuration).deleteShardByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all shards.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShardApi
     */
    ShardApi.prototype.getAllShards = function (options) {
        var _this = this;
        return (0, exports.ShardApiFp)(this.configuration).getAllShards(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get shard by ID.
     * @param {string} id Unique ID of shard.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShardApi
     */
    ShardApi.prototype.getShardByID = function (id, options) {
        var _this = this;
        return (0, exports.ShardApiFp)(this.configuration).getShardByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update shard by ID.
     * @param {string} id Unique ID of shard.
     * @param {IUpdateShardRequestDTO} [iUpdateShardRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShardApi
     */
    ShardApi.prototype.updateShardByID = function (id, iUpdateShardRequestDTO, options) {
        var _this = this;
        return (0, exports.ShardApiFp)(this.configuration).updateShardByID(id, iUpdateShardRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShardApi;
}(base_1.BaseAPI));
exports.ShardApi = ShardApi;
/**
 * SnapshotApi - axios parameter creator
 * @export
 */
var SnapshotApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get shard snapshot.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShardSnapshot: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/snapshot/shard";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get subnet snapshot.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetSnapshot: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/snapshot/subnet";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Publish shard snapshot to S3.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishShardSnapshot: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/snapshot/shard";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Publish subnet snapshot to S3.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishSubnetSnapshot: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/snapshot/subnet";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SnapshotApiAxiosParamCreator = SnapshotApiAxiosParamCreator;
/**
 * SnapshotApi - functional programming interface
 * @export
 */
var SnapshotApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SnapshotApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get shard snapshot.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShardSnapshot: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getShardSnapshot(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get subnet snapshot.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetSnapshot: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubnetSnapshot(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Publish shard snapshot to S3.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishShardSnapshot: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.publishShardSnapshot(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Publish subnet snapshot to S3.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishSubnetSnapshot: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.publishSubnetSnapshot(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SnapshotApiFp = SnapshotApiFp;
/**
 * SnapshotApi - factory interface
 * @export
 */
var SnapshotApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SnapshotApiFp)(configuration);
    return {
        /**
         * Get shard snapshot.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShardSnapshot: function (options) {
            return localVarFp.getShardSnapshot(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get subnet snapshot.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetSnapshot: function (options) {
            return localVarFp.getSubnetSnapshot(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Publish shard snapshot to S3.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishShardSnapshot: function (options) {
            return localVarFp.publishShardSnapshot(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Publish subnet snapshot to S3.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishSubnetSnapshot: function (options) {
            return localVarFp.publishSubnetSnapshot(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SnapshotApiFactory = SnapshotApiFactory;
/**
 * SnapshotApi - object-oriented interface
 * @export
 * @class SnapshotApi
 * @extends {BaseAPI}
 */
var SnapshotApi = /** @class */ (function (_super) {
    __extends(SnapshotApi, _super);
    function SnapshotApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get shard snapshot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapshotApi
     */
    SnapshotApi.prototype.getShardSnapshot = function (options) {
        var _this = this;
        return (0, exports.SnapshotApiFp)(this.configuration).getShardSnapshot(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get subnet snapshot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapshotApi
     */
    SnapshotApi.prototype.getSubnetSnapshot = function (options) {
        var _this = this;
        return (0, exports.SnapshotApiFp)(this.configuration).getSubnetSnapshot(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Publish shard snapshot to S3.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapshotApi
     */
    SnapshotApi.prototype.publishShardSnapshot = function (options) {
        var _this = this;
        return (0, exports.SnapshotApiFp)(this.configuration).publishShardSnapshot(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Publish subnet snapshot to S3.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapshotApi
     */
    SnapshotApi.prototype.publishSubnetSnapshot = function (options) {
        var _this = this;
        return (0, exports.SnapshotApiFp)(this.configuration).publishSubnetSnapshot(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SnapshotApi;
}(base_1.BaseAPI));
exports.SnapshotApi = SnapshotApi;
/**
 * SubnetApi - axios parameter creator
 * @export
 */
var SubnetApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create subnet.
         * @param {ICreateSubnetRequestDTO} [iCreateSubnetRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubnet: function (iCreateSubnetRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/subnet";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateSubnetRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete subnet by ID.
         * @param {string} id Unique ID of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubnetByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteSubnetByID', 'id', id);
                    localVarPath = "/farm-infra/subnet/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all subnets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubnets: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/farm-infra/subnet";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get subnet by cidr.
         * @param {string} cidr CIDR of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByCIDR: function (cidr, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'cidr' is not null or undefined
                    (0, common_1.assertParamExists)('getSubnetByCIDR', 'cidr', cidr);
                    localVarPath = "/farm-infra/subnet/cidr/{cidr}"
                        .replace("{".concat("cidr", "}"), encodeURIComponent(String(cidr)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get subnet by ID.
         * @param {string} id Unique ID of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getSubnetByID', 'id', id);
                    localVarPath = "/farm-infra/subnet/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get subnet by IP address.
         * @param {string} ipAddress IP address to find cidr.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByIPAddress: function (ipAddress, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ipAddress' is not null or undefined
                    (0, common_1.assertParamExists)('getSubnetByIPAddress', 'ipAddress', ipAddress);
                    localVarPath = "/farm-infra/subnet/cidr/ip/{ipAddress}"
                        .replace("{".concat("ipAddress", "}"), encodeURIComponent(String(ipAddress)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get subnet by openvpn client id.
         * @param {string} openvpnClientId Openvpn client id of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByOpenvpnClientID: function (openvpnClientId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'openvpnClientId' is not null or undefined
                    (0, common_1.assertParamExists)('getSubnetByOpenvpnClientID', 'openvpnClientId', openvpnClientId);
                    localVarPath = "/farm-infra/subnet/openvpnClientId/{openvpnClientId}"
                        .replace("{".concat("openvpnClientId", "}"), encodeURIComponent(String(openvpnClientId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update subnet by ID.
         * @param {string} id Unique ID of subnet.
         * @param {IUpdateSubnetRequestDTO} [iUpdateSubnetRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubnetByID: function (id, iUpdateSubnetRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateSubnetByID', 'id', id);
                    localVarPath = "/farm-infra/subnet/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateSubnetRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SubnetApiAxiosParamCreator = SubnetApiAxiosParamCreator;
/**
 * SubnetApi - functional programming interface
 * @export
 */
var SubnetApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SubnetApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create subnet.
         * @param {ICreateSubnetRequestDTO} [iCreateSubnetRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubnet: function (iCreateSubnetRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSubnet(iCreateSubnetRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete subnet by ID.
         * @param {string} id Unique ID of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubnetByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSubnetByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all subnets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubnets: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllSubnets(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get subnet by cidr.
         * @param {string} cidr CIDR of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByCIDR: function (cidr, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubnetByCIDR(cidr, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get subnet by ID.
         * @param {string} id Unique ID of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubnetByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get subnet by IP address.
         * @param {string} ipAddress IP address to find cidr.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByIPAddress: function (ipAddress, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubnetByIPAddress(ipAddress, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get subnet by openvpn client id.
         * @param {string} openvpnClientId Openvpn client id of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByOpenvpnClientID: function (openvpnClientId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubnetByOpenvpnClientID(openvpnClientId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update subnet by ID.
         * @param {string} id Unique ID of subnet.
         * @param {IUpdateSubnetRequestDTO} [iUpdateSubnetRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubnetByID: function (id, iUpdateSubnetRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSubnetByID(id, iUpdateSubnetRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SubnetApiFp = SubnetApiFp;
/**
 * SubnetApi - factory interface
 * @export
 */
var SubnetApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SubnetApiFp)(configuration);
    return {
        /**
         * Create subnet.
         * @param {ICreateSubnetRequestDTO} [iCreateSubnetRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubnet: function (iCreateSubnetRequestDTO, options) {
            return localVarFp.createSubnet(iCreateSubnetRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete subnet by ID.
         * @param {string} id Unique ID of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubnetByID: function (id, options) {
            return localVarFp.deleteSubnetByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all subnets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubnets: function (options) {
            return localVarFp.getAllSubnets(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get subnet by cidr.
         * @param {string} cidr CIDR of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByCIDR: function (cidr, options) {
            return localVarFp.getSubnetByCIDR(cidr, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get subnet by ID.
         * @param {string} id Unique ID of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByID: function (id, options) {
            return localVarFp.getSubnetByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get subnet by IP address.
         * @param {string} ipAddress IP address to find cidr.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByIPAddress: function (ipAddress, options) {
            return localVarFp.getSubnetByIPAddress(ipAddress, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get subnet by openvpn client id.
         * @param {string} openvpnClientId Openvpn client id of subnet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubnetByOpenvpnClientID: function (openvpnClientId, options) {
            return localVarFp.getSubnetByOpenvpnClientID(openvpnClientId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update subnet by ID.
         * @param {string} id Unique ID of subnet.
         * @param {IUpdateSubnetRequestDTO} [iUpdateSubnetRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubnetByID: function (id, iUpdateSubnetRequestDTO, options) {
            return localVarFp.updateSubnetByID(id, iUpdateSubnetRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SubnetApiFactory = SubnetApiFactory;
/**
 * SubnetApi - object-oriented interface
 * @export
 * @class SubnetApi
 * @extends {BaseAPI}
 */
var SubnetApi = /** @class */ (function (_super) {
    __extends(SubnetApi, _super);
    function SubnetApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create subnet.
     * @param {ICreateSubnetRequestDTO} [iCreateSubnetRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubnetApi
     */
    SubnetApi.prototype.createSubnet = function (iCreateSubnetRequestDTO, options) {
        var _this = this;
        return (0, exports.SubnetApiFp)(this.configuration).createSubnet(iCreateSubnetRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete subnet by ID.
     * @param {string} id Unique ID of subnet.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubnetApi
     */
    SubnetApi.prototype.deleteSubnetByID = function (id, options) {
        var _this = this;
        return (0, exports.SubnetApiFp)(this.configuration).deleteSubnetByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all subnets.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubnetApi
     */
    SubnetApi.prototype.getAllSubnets = function (options) {
        var _this = this;
        return (0, exports.SubnetApiFp)(this.configuration).getAllSubnets(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get subnet by cidr.
     * @param {string} cidr CIDR of subnet.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubnetApi
     */
    SubnetApi.prototype.getSubnetByCIDR = function (cidr, options) {
        var _this = this;
        return (0, exports.SubnetApiFp)(this.configuration).getSubnetByCIDR(cidr, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get subnet by ID.
     * @param {string} id Unique ID of subnet.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubnetApi
     */
    SubnetApi.prototype.getSubnetByID = function (id, options) {
        var _this = this;
        return (0, exports.SubnetApiFp)(this.configuration).getSubnetByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get subnet by IP address.
     * @param {string} ipAddress IP address to find cidr.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubnetApi
     */
    SubnetApi.prototype.getSubnetByIPAddress = function (ipAddress, options) {
        var _this = this;
        return (0, exports.SubnetApiFp)(this.configuration).getSubnetByIPAddress(ipAddress, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get subnet by openvpn client id.
     * @param {string} openvpnClientId Openvpn client id of subnet.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubnetApi
     */
    SubnetApi.prototype.getSubnetByOpenvpnClientID = function (openvpnClientId, options) {
        var _this = this;
        return (0, exports.SubnetApiFp)(this.configuration).getSubnetByOpenvpnClientID(openvpnClientId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update subnet by ID.
     * @param {string} id Unique ID of subnet.
     * @param {IUpdateSubnetRequestDTO} [iUpdateSubnetRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubnetApi
     */
    SubnetApi.prototype.updateSubnetByID = function (id, iUpdateSubnetRequestDTO, options) {
        var _this = this;
        return (0, exports.SubnetApiFp)(this.configuration).updateSubnetByID(id, iUpdateSubnetRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SubnetApi;
}(base_1.BaseAPI));
exports.SubnetApi = SubnetApi;
